import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { GlobalContext } from "../context/GlobalContext";
import SectionTitle from "../component/SectionTitle";
export default function ResetPassword(props) {
  const { register, handleSubmit, errors, getValues } = useForm();
  const [showResetDiv, setShowResetDiv] = useState(false);
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");
  // const { showNotification } = useContext(GlobalContext);
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    errors: errors1,
  } = useForm();

  const submitCode = async (value) => {
    const res = await axios.post("api/submit_reset_code", value);
    if (res.data.status == "success") {
      // showNotification(true, "success", res.data.message);
      setShowResetDiv(true);
    } else {
      // showNotification(true, "error", res.data.message);
    }
  };
  const onSubmit = async (value) => {
    const res = await axios.post("api/user_change_password", value);
    if (res.data.status == "success") {
      // showNotification(true, "success", res.data.message);
      window.localStorage.removeItem("rp_email");
      window.localStorage.removeItem("rp_mobile");
      window.localStorage.removeItem("rp_type");
      props.history.push("/login");
    } else {
      // showNotification(true, "error", res.data.message);
    }
  };

  useEffect(() => {
    const rp_email = window.localStorage.getItem("rp_email");
    if (rp_email) {
      setEmail(rp_email);
    } else {
      setEmail("");
    }
    const rp_mobile = window.localStorage.getItem("rp_mobile");
    if (rp_mobile) {
      setMobile(rp_mobile);
    } else {
      setMobile("");
    }
    const rp_type = window.localStorage.getItem("rp_type");
    if (rp_type) {
      setType(rp_type);
    } else {
      setType("");
    }
  }, []);

  return (
    <div className="section-full p-t120  p-b60 site-bg-light pattern-bg">
      <div className="container form_verify">
        <SectionTitle title="Reset Password" />


        <div className="row">
          <div className="col-xl-8 col-lg-7 col-md-6">
            <div className="twm-log-reg-form-wrap mt-0">
              <div className="sidenav_main_content customize_form" style={{ display: showResetDiv ? "none" : "block" }}>

                <form onSubmit={handleSubmit1(submitCode)}>
                  <div className="form-group text-center">
                    <label className="col-md-12 mb-3">
                      Enter the <mark>Code</mark>
                    </label>
                    <div className="col-md-12">
                      <input
                        type="hidden"
                        name="email" className="form-control sd"
                        defaultValue={email}
                        ref={register1}
                      />
                      <input
                        type="hidden"
                        name="mobile" className="form-control"
                        defaultValue={mobile}
                        ref={register1}
                      />
                      <input
                        type="hidden"
                        name="type" className="form-control"
                        defaultValue={type}
                        ref={register1}
                      />
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter the reset code"
                        name="reset_code"
                        ref={register1({
                          required: "Required",
                        })}
                        style={{
                          border: errors1.reset_code && "1px solid #ff0000",
                        }}
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <button className="site-button" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
              <div
          id="change_password"
          style={{ display: showResetDiv ? "block" : "none" }}
        >
          <div className="sidenav_main_content customize_form">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group row">
                <label className="col-lg-12 col-md-12">New Password</label>
                <div className="col-lg-12 col-md-12">
                  <input
                    type="hidden"
                    name="email"  className="form-control"
                    defaultValue={email}
                    ref={register}
                  />
                  <input
                    type="hidden"
                    name="mobile"  className="form-control"
                    defaultValue={mobile}
                    ref={register}
                  />
                  <input
                    type="hidden"
                    name="type"  className="form-control"
                    defaultValue={type}
                    ref={register}
                  />
                  <input
                    type="password"
                    placeholder="Enter new password"
                    name="password"  className="form-control"
                    ref={register({
                      required: "Required",
                      minLength: {
                        value: 8,
                        message: "Password Must Be Minimun of 8 Characters",
                      },
                    })}
                    style={{
                      border: errors.password && "1px solid #ff0000",
                    }}
                  />
                  {errors.password && (
                    <div>
                      <span className="text-danger">
                        {errors.password.message}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-lg-12 col-md-12">Confirm New Password</label>
                <div className="col-lg-12 col-md-12">
                  <input
                    type="password"
                    placeholder="Confirm new password"
                    name="password_confirmation" className="form-control"
                    ref={register({
                      required: "Required",
                      validate: (value) =>
                        value === getValues("password") ||
                        "Password Must Match",
                    })}
                    style={{
                      border:
                        errors.password_confirmation && "1px solid #ff0000",
                    }}
                  />
                  {errors.password_confirmation && (
                    <div>
                      <span className="text-danger">
                        {errors.password_confirmation.message}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="text-center">
                <button className="site-button" type="submit">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-5 col-md-6">
            <figure className="account-image">
              <img src="/portal/images/login.png" alt="info image" />
            </figure>
          </div>
        </div>

        

      </div>
    </div>
  );
}
